<template>
  <div class="">
    <top-header :type="6" :placeholder="'房屋备案状态查询'" fontSize="0.32rem" />
    <div class="form_con">
      <van-form @submit="onSubmit">
        <van-field
          v-model="projectName"
          name="项目名称"
          label="项目名称"
          placeholder="请输入项目名称"
          readonly
          clickable
          @click="showProject = true"
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="build"
          label="楼号"
          placeholder="选择楼号"
          @click="showBuild = true"
        />
        <van-popup v-model="showBuild" position="bottom">
          <van-picker
            show-toolbar
            :columns="buildArr"
            value-key="newKey"
            @confirm="confirmBuild"
            @cancel="showBuild = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="unit"
          label="单元号"
          placeholder="选择单元号"
          @click="showUnit = true"
        />
        <van-popup v-model="showUnit" position="bottom">
          <van-picker
            show-toolbar
            :columns="unitArr"
            value-key="unitNo"
            @confirm="confirmUnit"
            @cancel="showUnit = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="room"
          label="房号"
          placeholder="选择房号"
          @click="showRoom = true"
        />
        <van-popup v-model="showRoom" position="bottom">
          <van-picker
            show-toolbar
            :columns="houseArr"
            value-key="houseNo"
            @confirm="confirmRoom"
            @cancel="showRoom = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="use"
          label="房屋类型"
          placeholder="选择房屋类型"
          @click="showUse = true"
        />
        <van-popup v-model="showUse" position="bottom">
          <van-picker
            show-toolbar
            :columns="useArr"
            @confirm="confirmUse"
            @cancel="showUse = false"
          />
        </van-popup>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
    <van-overlay :show="showProject" @click="showProject = false">
    </van-overlay>
    <div class="wrapper" @click.stop v-show="showProject">
      <van-search v-model="keyWord" placeholder="请输入搜索关键词" />
      <div class="select_con" v-show="projectList.length">
        <p v-for="(item, index) in projectList" :key="index" @click="setVal(item.tgmc, item.itemId,item.old)">{{item.tgmc}}({{item.xmmc}})</p>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import topHeader from '@/components/header';
export default {
  data() {
    return {
      projectName: '',
      keyWord: '',
      build: '',
      unit: '',
      room: '',
      use: '',
      showProject: false,
      showBuild: false,
      showUnit: false,
      showRoom: false,
      showUse: false,
      projectList: [],
      jsonArr: [],
      buildArr: [],
      unitArr: [],
      roomArr: [],
      houseArr: [],
      useArr: [],
      form: {
        itemId: '',
        buildId: '',
        unitNo: '',
        room: '',
        use: '',
        old:''
      }
    };
  },
  components: {
    topHeader
  },
  watch: {
    keyWord(n) {
      this.$set(this, 'projectList', [])
      const newArr = []
      this.jsonArr.forEach(function (item) {
        if ((item.tgmc.includes(n)|| item.xmmc.includes(n))&& item.old === '0') {
          newArr.push(item)
        }
      })
      this.$set(this, 'projectList', newArr);
      if(n === '') {
        this.$set(this, 'projectList', [])
      }
    }
  },
  mounted() {
    this.getProjectName()
  },
  methods: {
    getBuild() {
      this.$new.post('sale/getBuildByItemId.do', qs.stringify({
        itemId: this.form.itemId
      })).then(res => {
        const newArr = [];
        if(res.obj) {
          res.obj.forEach(item => {
            item.newKey = item.buildName + '(' + item.certificateNo + ')'
            newArr.push(item)
          })
        }
        this.$set(this, 'buildArr', newArr);
      })
    },
    getUnit() {
      this.$new.post('sale/getUnitNoByBuildId.do', qs.stringify({
        buildId: this.form.buildId
      })).then(res => {
        this.$set(this, 'unitArr', res.obj || [])
      })
    },
    getRoom() {
      this.$new.post('sale/getHouseNoByUnitNoBuildId.do', qs.stringify({
        buildId: this.form.buildId,
        unitNo: this.form.unitNo
      })).then(res => {
        this.$set(this, 'houseArr', res.obj || [])
      })
    },
    getUse() {
      this.$new.post('sale/getSaleHouseUseByBuildId.do', qs.stringify({
        buildId: this.form.buildId,
      })).then(res => {
        this.$set(this, 'useArr', res.obj || [])
      })
    },
    confirmBuild(n) {
      for(let key in this.form) {
        if(key != 'itemId' && key!= 'buildId') {
          this.form[key] = '';
        }
      }
      this.unit = '';
      this.room = '';
      this.use = '';
      this.$set(this, 'roomArr', [])
      this.build = n.newKey;
      this.$set(this.form, 'buildId', n.buildId);
      this.showBuild = false;
      this.getUnit();
      this.getUse();
    },
    confirmUnit(n) {
      this.unit = n.unitNo;
      this.$set(this.form, 'unitNo', n.unitNo);
      this.showUnit = false;
      this.getRoom();
    },
    confirmRoom(n) {
      this.room = n.houseNo;
      this.$set(this.form, 'room', n.houseId);
      this.showRoom = false;
    },
    confirmUse(n) {
      this.use = n;
      this.$set(this.form, 'use', n);
      this.showUse = false;
    },
    setVal(name, id,old) {
      for(let key in this.form) {
        if(key != 'itemId') {
          this.form[key] = '';
        }
      }
      this.unit = '';
      this.build = '';
      this.room = '';
      this.use = '';
      this.$set(this, 'unitArr', [])
      this.$set(this, 'roomArr', [])
      this.$set(this, 'useArr', [])
      this.projectName = name;
      this.$set(this.form, 'itemId', id);
      this.$set(this.form, 'old', old);
      this.showProject = false;
      this.getBuild();
    },
    getProjectName() {
      this.$new.post('/itemInfo/getItemSearch.do').then(res => {
        this.jsonArr = res.obj
      })
    },
    onSubmit() {
      if(this.form.old==0){
        this.$router.push({
          path: '/saleInfo',
          query: {
            itemId: this.form.itemId,
            buildId:this.form.buildId,
            unitNo:this.form.unitNo,
            houseId:this.form.room,
            saleHouseUse:this.form.use
          }
        })
      }else{
        this.$router.push({
          path: '/projectDetailIndex',
          query: {
            itemId: this.form.itemId
          }
        })
      }
    }
  },
};
</script>
<style lang="less" scoped>
.wrapper{
    position: fixed;
    top: 1.2rem;
    left: 0.23rem;
    right: 0.23rem;
    z-index: 5;
    .van-search{
      border-radius: 0.06rem 0.06rem 0 0;
    }
    .select_con{
      width: 100%;
      height: 50vh;
      background-color: #fff;
      padding: 0 12px;
      box-sizing: border-box;
      overflow: auto;
      p{
        font-size: 14px;
        padding: 10px 10px;
        border-bottom: 1px solid #f5f5f5;
      }
    }
  }
</style>